<ng-container [ngSwitch]="value">
  <span i18n="TherapyResponse.Notes@@sensitive" *ngSwitchCase="'Sensitive'">sensitive</span>
  <span i18n="TherapyResponse.Notes@@resistance" *ngSwitchCase="'Resistant'">resistance</span>
  <span i18n="TherapyResponse.Notes@@lower-response" *ngSwitchCase="'DecreasedResponse'"
    >lower response</span
  >
</ng-container>
